module.exports = __webpack_public_path__ + "public/img/logo彩白.fcedcdcb.png";